export const PAGINATION_DATA = {
    content: [],
    page: {
        offset: 0,
        currentPage: 1,
        totalPages: 0,
        size: 30,
        total: 0,
    }
}